import { combineReducers } from 'redux'
import type { Campaign } from 'types/content-editor'
import { campaignEditorReducer } from './campaign-editor'
import type { State as CampaignsFooterState } from './campaign-footers'
import { campaignFootersReducer } from './campaign-footers'
import type { State as CampaignListState } from './campaign-list'
import { campaignListReducer } from './campaign-list'
import type { State as CampaignSearchState } from './campaign-search'
import { campaignSearchReducer } from './campaign-search'
import type { State as NewCampaignModalState } from './new-campaign-modal'
import { newCampaignModal } from './new-campaign-modal'
import type { State as RecipientRulesState } from './recipient-rules'
import { recipientRulesReducer } from './recipient-rules'
export type EmailCampaignsState = {
  campaignEditor: Campaign
  newCampaignModal: NewCampaignModalState
  campaignList: CampaignListState
  recipientRules: RecipientRulesState
  campaignFooters: CampaignsFooterState
  campaignSearch: CampaignSearchState
}
// reducer combines form related reducers
export const campaignsReducer = combineReducers({
  campaignEditor: campaignEditorReducer,
  newCampaignModal: newCampaignModal,
  campaignList: campaignListReducer,
  recipientRules: recipientRulesReducer,
  campaignFooters: campaignFootersReducer,
  campaignSearch: campaignSearchReducer,
})
